import { Button } from '@repo/ui/components/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@repo/ui/components/dialog';

interface LimitReachedDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  feature: 'wishlist' | 'occasions';
  limit: number;
}

const featureNames = {
  wishlist: 'presentes',
  occasions: 'ocasiões',
};

export function LimitReachedDialog({
  open,
  onOpenChange,
  feature,
  limit,
}: LimitReachedDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Limite atingido</DialogTitle>
          <DialogDescription>
            Você atingiu o limite de {limit} {featureNames[feature]} do plano
            gratuito.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Entendi
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
